import store from '../store/store'
import axios from 'axios'

export default {
    ifAuthenticated (to, from, next) {
      if (store.getters.isAuthenticated) {
        axios.defaults.headers = { 'Authorization': store.state.token }
        next()
      }else{
        next('/login')
      }
    },
  
    ifNotAuthenticated (to, from, next) {
      if (!store.getters.isAuthenticated) {
        axios.defaults.headers = { 'Authorization': '' }
        next()
        return
      }
      next('/home')
    },

    isAdmin (to, from, next) {
      console.log('guard :' , store.state.user.Type.toLowerCase())
      console.log('to :' , to)
      console.log('from :' , from)
      if (store.state.user.Type.toLowerCase() != 'admin') {
        next('/home')
        return
      }
      next()
    },

  }